<div class="rs-modal-close">
  <button
    class="rs-link-action rs-link-action-close rs-link-action-neg close-reveal-modal"
    (click)="close()"
  >
    <span class="rs-action-link-icon" title="{{ 'common.overlayer.close.caption' | translate }}"
      ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
    >
  </button>
</div>
<div class="rs-modal-heading">
  <h2 class="rs-modal-heading-title" id="modal_label">
    {{ 'option.details.disneyplus.popup.title' | translate }}
  </h2>
</div>
<div
  class="rs-modal-content"
  [innerHTML]="'option.details.disneyplus.popup.content' | translate"
></div>
